import { defineRecipe } from '@chakra-ui/react'

export const headingRecipe = defineRecipe({
  className: 'chakra-heading',
  base: {
    fontFamily: 'heading',
    fontWeight: 'extrabold',
    letterSpacing: 'tight',
  },
  variants: {
    size: {
      xs: {
        textStyle: 'xs',
      },
      sm: {
        textStyle: 'sm',
      },
      md: {
        textStyle: 'md',
      },
      lg: {
        textStyle: 'lg',
        letterSpacing: 'tighter',
      },
      xl: {
        textStyle: 'xl',
        letterSpacing: 'tighter',
      },
      '2xl': {
        textStyle: '2xl',
        letterSpacing: 'tighter',
      },
      '3xl': {
        textStyle: '3xl',
        letterSpacing: 'tighter',
      },
      '4xl': {
        textStyle: '4xl',
        letterSpacing: 'tighter',
      },
      '5xl': {
        textStyle: '5xl',
        letterSpacing: 'tighter',
      },
      '6xl': {
        textStyle: '6xl',
        letterSpacing: 'tighter',
      },
      '7xl': {
        textStyle: '7xl',
        letterSpacing: 'tighter',
      },
      '8xl': {
        textStyle: '8xl',
        letterSpacing: 'tighter',
      },
    },
  },
  defaultVariants: {
    size: 'xl',
  },
})
